const trackingUtils = require('od-modules/utils/tracking.utils');
const mpiRoutes = require('od-modules/enums/mpi_routes.enum');
const store = require('od-modules/store/results');
const actions = require('od-modules/store/results/action_creators');
const sortTypes = require('od-modules/utils/sort_types');
const insuranceCatalogueCollection = require('od-modules/collections/insurance_catalogue.collection');
const isDynpack = Odigeo.Utils.isRequestApp('dp');

const createLegInformation = function(legModel) {
    return Odigeo._.extend({}, legModel, {
        name: legModel.airport + ', ' + legModel.city,
    });
};

const parseSegment = function(leg, tests, segment) {
    return Odigeo._.extend(segment, {
        departureInfo: createLegInformation(segment.departureInfo),
        arrivalInfo: createLegInformation(segment.arrivalInfo),
        carrierCode: leg.carrierCode,
        numSeatsLeft: segment.numSeatsLeft,
    });
};

const initTranslations = function(translations) {
    if (Odigeo._.isEmpty(this.get('translations'))) {
        this.set('translations', translations);
        store.dispatch(actions.setTranslations(translations));
    }
};

module.exports = Odigeo.Model.extend({
    dataURL: 'data',
    data: {},
    isEmptyData: false,
    delta: 0,
    actualPage: 1,
    totalPages: 0,
    trackingLabel: 'page_selected_1',
    // number of results in the current search
    numberOfResults: Infinity,
    mpiRoutes: mpiRoutes,
    numberOfFilteredResults: Infinity,
    numberOfPreFilteredResults: Infinity,
    bookedFlights: [],
    isOdiRatingActive: null,
    defaults: {
        isFiltersApplied: false,
        allowedRefresh: true,
        activeTab: 'all',
        itineraries: [],
        animatedSeatsCounter: 0,
        timesSeatsAnimationDisplayed: 0,
        isMembershipFare: true,
        isPriceWithoutDiscountSelected: false,
    },

    init: function() {
        this.widget.options = Odigeo.Utils.parseOptions(this.widget.options);
        this.set('isMobile', Odigeo._.isObject(this.widget.options.config) && this.widget.options.config.device === 'mobile');
        this.set('scrollToItineraryDone', false);
        this.setActiveTab();
    },

    setActiveTab: function() {
        var tests = this.widget.options.tests;
        if (tests.sortingTabsEnabled) {
            if (tests.sortingTabsPartition === 2) {
                this.set('activeTab', sortTypes.byRecommended.trackingLabel);
            } else if (tests.sortingTabsPartition === 3) {
                this.set('activeTab', sortTypes.byPrice.trackingLabel);
            }
        }
    },

    // Method overwritten from Odigeo, overriding of dataRequestSettings param won't work
    getDataRequestSettings: function() {
        return {
            type: 'GET',
            data: this._getResultJSONData(),
            cache: false,
            success: Odigeo._.bind(this.requestSuccessHandler, this),
            error: Odigeo._.bind(this.requestErrorHandler, this),
        };
    },

    mustOpenSearchSummary: function() {
        return this.widget.options.applyMetaPaxEdit;
    },

    getBookedFlights: function() {
        return this.bookedFlights;
    },

    setBookedFlights: function(bookedFlights) {
        this.bookedFlights = bookedFlights;
    },

    calculateStayDays: function(flights) {
        let stayDays = 0;
        if (flights.length > 1) {
            stayDays = Odigeo.Utils.getDifferenceInDays(
                new Date(flights[0].jsArrivalDate).getTime(),
                new Date(flights[1].jsDepartureDate).getTime()
            );
        }
        return stayDays;
    },

    fetchAveragePrice: function() {
        var model = this.widget.model;
        return this.fetch({
            url: Odigeo.Settings.getProperty('searchServiceUrlFormatter')('averageprice'),
            parse: false,
            dataType: 'json',
            contentType: 'application/json',
            type: 'GET',
        }).then(function(data) {
            model.set('averagePrice', data);
        });
    },

    updateSavingAlerts: function() {
        if (!this.get('isMembershipPriceDisplay')) {
            this.widget.setSavingAlerts();
        }
    },

    renderFlexInfo() {
        const insuranceCatalogue = insuranceCatalogueCollection.getInstance();
        insuranceCatalogue.getLoadedPromise().then((loaded) => {
            if (loaded && insuranceCatalogue.isCancellationFreeCandidate()) {
                if (Odigeo.Utils.parseJson(Odigeo.Session.get('isFlexibilityDisruptionWaitingActive'))) {
                    this.widget.view.renderFlexInfo();
                }
            }
        });
    },

    renderFlightChangeFreeInfo() {
        this.widget.view.renderFlightChangeFreeInfo();
    },

    renderChangeDateOptionEligible() {
        this.widget.view.renderChangeDateOptionEligible();
    },

    renderMembershipFlexibilityAlert() {
        this.widget.view.renderMembershipFlexibilityAlert();
    },

    errorfetchAveragePrice: function() {
        trackingUtils.trackEvent('fetch_error', 'fetch_average_price', true);
    },

    getSegmentDetails: function(fareItineraryId, itineraryGroupId, segmentId, isHubItinerary, isSmartHubItinerary, searchId) {
        // eslint-disable-next-line no-restricted-properties
        return $.ajax({
            url: Odigeo.Settings.property('appContext') + '/widget/itinerary_details',
            method: 'GET',
            data: {
                id: 'details-' + [fareItineraryId, itineraryGroupId, segmentId].join('-'),
                fareitinerary: fareItineraryId,
                itinerarygroup: itineraryGroupId,
                segmentId: segmentId,
                isHubItinerary: isHubItinerary,
                isSmartHubItinerary: isSmartHubItinerary,
                searchId: searchId,
            },
        });
    },

    _getResultJSONData: function() {
        this.totalPages = Math.ceil(this.numberOfFilteredResults / this.widget.resultsByPage);
        return {
            from: this.calculateResultsOnPageDiff(0),
            to: this.calculateResultsOnPageDiff(1),
            isDynpack: Odigeo.Utils.isRequestApp('dp'),
            selectedSearchResults: this.widget.selectedSearchResults,
            dynpackCartProductId: Odigeo._.get(this, 'widget.dynpackCartProductId'),
            flightPreselectedId: Odigeo._.get(this, 'widget.dpCart.flightPreselectedId', ''),
            firstSegmentSelected: Odigeo._.get(this, 'widget.dpCart.segmentsPreselected[0].key', ''),
            secondSegmentSelected: Odigeo._.get(this, 'widget.dpCart.segmentsPreselected[1].key', ''),
        };
    },

    calculateResultsOnPageDiff: function(diff) {
        return ((this.calculateCurrentPagination(this.widget.pageToLoad)) + diff) * this.widget.resultsByPage;
    },

    calculateCurrentPagination: function(page) {
        return page === 0 ? 0 : page -1;
    },

    url: function() {
        return Odigeo.Settings.property('widgetPartUrlFormatter')(this.widget.name, this.dataURL);
    },

    parse: function(data) {
        return Odigeo._.extend(data, {
            items: Odigeo._.map(data.items, this.parseItem, this),
        });
    },

    parseItem: function(item) {
        return Odigeo._.extend(item, {
            itineraryGroupsList: Odigeo._.map(item.itineraryGroupsList, this.parseLeg, this),
        });
    },

    parseLeg: function(leg) {
        return Odigeo._.extend(leg, {
            segItems: Odigeo._.map(leg.segItems, Odigeo._.partial(parseSegment, leg, this.widget.options.tests)),
        });
    },

    requestSuccessHandler: function(rawData) {
        var widget = this.widget;
        var jsonData = Odigeo.Utils.parseJson(rawData) || {};
        var firstItemCcfee = Odigeo._.isArray(jsonData.items) && parseInt(jsonData.items[0].ccFee, 10);
        var bestFlights;
        var itineraries = this.getItinerariesFromJsonData(jsonData);
        var currentItineraries = itineraries.currentItineraries;
        var allItineraries = itineraries.allItineraries;
        var renderMetricKey = isDynpack ? 'LOAD_RENDER_RESULTS_DP' : 'LOAD_RENDER_RESULTS_FLIGHTS';
        trackingUtils.startMetric(renderMetricKey);

        this.set('inconvenientTracking', jsonData.inconvenientTracking);
        // TEST A/B [PGRTOF-4180] Communication full transparency
        if (firstItemCcfee === 0) {
            Odigeo.trigger(this.widget.id + ':displayBanner');
        }

        jsonData = this.parse(jsonData);
        // END TEST A/B [PGRTOF-4180] Communication full transparency
        this.set('data', jsonData);
        this.set('fareItineraries', currentItineraries);
        this.set('currentFareItineraries', currentItineraries);
        initTranslations.call(this, jsonData.translations);
        store.dispatch(actions.setTopItineraries(jsonData.topItineraries));
        bestFlights = this.getFareItineraryByIndexId('0');
        if (!Odigeo._.isUndefined(bestFlights)) {
            this.set('bestFlightsItinerary', bestFlights);
        }
        this.isFiltering = this.numberOfResults !== this.numberOfPreFilteredResults;

        this.set('searchType', jsonData.searchType);
        if (widget.paginationType === 'loadMore') {
            this.set('fareItineraries', allItineraries);
            if (this.delta === 1) {
                widget.pageBottomLoaded = widget.pageBottomRequested;
            } else if (this.delta === -1) {
                widget.pageTopLoaded = widget.pageTopRequested;
            }
        } else {
            this.actualPage = widget.pageToLoad;
        }

        this.set('isMembershipPriceOrDualPriceDisplay', jsonData.isMembershipPriceDisplay || jsonData.isMembershipDualPriceAbActive);
        this.set('isMembershipPriceDisplay', jsonData.isMembershipPriceDisplay);

        // Process the search result items and add each one to the DOM
        const callbackFunction = jsonData.isMainBatch ? Odigeo._.bind(this._onCompleteAddResults, this) : () => undefined;
        this.widget.view.addResults(jsonData, callbackFunction);

        if (this.numberOfResults === this.numberOfFilteredResults &&
                !this.get('isFiltersApplied')) {
            Odigeo.trigger(this.widget.id + ':hideFiltersApplied');
        }

        if (Odigeo.Membership.isPrimeToggleEnabled) {
            Odigeo.trigger(this.widget.id + ':onRenderPrimeToggleKey', jsonData.membershipSubscriptionPriceFmtd);
        }

        if (jsonData.isMainBatch) {
            var price = this.get('data').inconvenientTracking.cheapestItineraryPrice;
            this.setCheapestItineraryPrice(price);
            this.widget.requestFlexibleDates();
            this.widget.updateCompressedHeader();
            this.storeRecommendedPrice();
            Odigeo.trigger(this.widget.id + ':firstBatchLoadResults');
        }
        Odigeo.trigger(`${this.widget.id}:dynpackDisclaimer`, jsonData);
    },

    doItinerariesHaveSameFlightsNumbers: function(itinerary1, itinerary2) {
        // check the flights numbers in each segment of each itinerary
        for (let i = 0; i < itinerary1.itineraryGroupsList.length; i++) {
            const segItems1 = itinerary1.itineraryGroupsList[i].segItems;
            const segItems2 = itinerary2.itineraryGroupsList[i].segItems;
            for (let j = 0; j < segItems1.length; j++) {
                if (segItems1[j].flightNumbers !== segItems2[j].flightNumbers) {
                    return false;
                }
            }
        }
        return true;
    },

    removeMetaItinerary: function(itineraries, metaItineraryID) {
        return _.filter(itineraries.items, (itinerary) => {
            let isRegularItinerary = true;
            if (itinerary.mainItineraryId === metaItineraryID) { // could be metabox
                isRegularItinerary = !this.doItinerariesHaveSameFlightsNumbers(itinerary, itineraries.fareItineraryFromMetaSearch);
            }
            return isRegularItinerary;
        });
    },

    removeDuplicatedItinerariesFrom: function(itineraries) {
        return itineraries.filter((itinerary, index, array) => {
            const duplicate = array.find((otherItinerary, otherIndex) => {
                if (index === otherIndex) return false; // same itinerary
                if (itinerary.mainItineraryId !== otherItinerary.mainItineraryId) return false; // different ID
                return this.doItinerariesHaveSameFlightsNumbers(itinerary, otherItinerary);
            });
            // if there is no duplicate, keep the itinerary
            return duplicate === undefined;
        });
    },

    prepareNewItineraries: function(newItineraries) {
        // check all itineraries for duplicates: the ones already on screen + the new ones
        const uniqueItineraries = this.removeDuplicatedItinerariesFrom([...this.get('fareItineraries'), ...newItineraries]);
        // return only the new unique itineraries
        return uniqueItineraries.slice(this.get('fareItineraries').length);
    },

    getItinerariesFromJsonData: function(jsonData) {
        var metaItineraryID = this.landingToResultsFromMeta(jsonData) ? jsonData.fareItineraryFromMetaSearch.mainItineraryId : '';
        var itineraryFromMetaSearch = metaItineraryID !== '' ? [jsonData.fareItineraryFromMetaSearch] : [];
        var itinerariesWithoutMeta = this.removeMetaItinerary(jsonData, metaItineraryID);
        const currentItineraries = Odigeo.SessionScope.isMetaFlights && this.widget.pageToLoad > 1
            ? this.prepareNewItineraries(itinerariesWithoutMeta)
            : itineraryFromMetaSearch.concat(itinerariesWithoutMeta);
        var itinerariesToBePrepended = this.widget.pageToLoad === 1 ? itineraryFromMetaSearch : this.get('fareItineraries');
        return {currentItineraries, allItineraries: itinerariesToBePrepended.concat(itinerariesWithoutMeta)};
    },

    storeRecommendedPrice: function() {
        var recommendedItinerary = this.getRecommendedItinerary();
        Odigeo.Storage.set('odiRatingPrice', Odigeo._.get(recommendedItinerary, 'price', 0));
    },

    _onCompleteAddResults: function(widgetContent) {
        var isRequestDp = Odigeo.Utils.isRequestApp('dp');
        this.widget.updateSelectorToCache('bookingError', this.widget.view.$el.find('.booking_error'));
        this.widget.view.adjustResults();
        this.widget.view.updateResultsCount(this.widget.model.numberOfFilteredResults, this.widget.model.numberOfResults);
        if (!this.isFiltering) {
            this.widget.view.firstResultsFill(widgetContent);
        }
        this.widget.changePaymentDisclaimer();
        if (Odigeo.Session.get('showAddPaxError') === 'true') {
            Odigeo.trigger(this.widget.id + ':addPaxErrorMessage');
            Odigeo.Session.remove('showAddPaxError');
        }
        Odigeo.trigger(this.widget.id + ':resultsLoaded', this.numberOfFilteredResults !== this.numberOfResults);

        if (this.get('data').fareItineraryFromMetaSearch) {
            trackingUtils.stopMetric('LOAD_META_RESULTS');
        } else {
            const renderMetricKey = isRequestDp ? 'LOAD_RENDER_RESULTS_DP' : 'LOAD_RENDER_RESULTS_FLIGHTS';
            const resultsMetricKey = isRequestDp ? 'LOAD_RESULTS_DP_FLIGHTS' : 'LOAD_RESULTS_FLIGHTS' + Odigeo.AB.resultsLoadTimeTestPartitionSuffix;
            const ofMetricKey = isRequestDp ? 'LOAD_BACK_RESULTS_DP_OF' : 'LOAD_BACK_RESULTS_FLIGHTS_OF';
            trackingUtils.stopMetric(renderMetricKey);
            trackingUtils.stopMetric(resultsMetricKey);
            trackingUtils.trackStop(ofMetricKey);
        }

        this._terminateLoad();

        Odigeo.trigger(this.widget.id + ':updateCalendarGrid');
    },
    _terminateLoad() {
        const {showSingleDisclaimerItineraryResults, isSavingAlertsEnabled} = this.widget.options;
        const deferred = $.Deferred();
        const isReturningUser = !Odigeo._.isEmpty(this.get('data').returningUserDeviceId);
        let fetchAveragePricePromise;

        deferred.resolve();
        if (showSingleDisclaimerItineraryResults) {
            this.widget.view.allocateDisclaimer();
        }
        this.isFiltering = false;
        this.delta = 0;
        if (isSavingAlertsEnabled) {
            fetchAveragePricePromise = this.get('averagePrice') ? deferred.promise() : this.fetchAveragePrice();
            fetchAveragePricePromise
                .then(Odigeo._.bind(this.updateSavingAlerts, this), this.errorfetchAveragePrice)
                .then(() => Odigeo.trigger(this.widget.id + ':trackOnloadEvents'));
            Odigeo.trigger(this.widget.id + ':stopFilterFlightsTime');
        }
        trackingUtils.setCustomDimension('personalized_sorting', isReturningUser.toString());
        Odigeo.trigger(this.widget.id + ':dataLoaded', !isSavingAlertsEnabled);
        Odigeo.trigger(this.widget.id + ':trackOnloadTrains');
        if (Odigeo.AB.isMPIRouteDesktop && this.isMPIRoute()) {
            Odigeo.trigger(this.widget.id + ':trackMPISearchTime');
        }
        this.renderFlexInfo();
        if (Odigeo.Membership.isMembershipFlexibilityD) {
            this.renderMembershipFlexibilityAlert();
        } else if (Odigeo.SessionScope.flow === 'desktop' && (Odigeo.AB.isChangeFlightFreeChargeDesktop || Odigeo.AB.isPrimeDays)) {
            this.renderChangeDateOptionEligible();
            this.renderFlightChangeFreeInfo();
        }
    },

    isMPIRoute: function() {
        var departureIATA = Odigeo.Storage.get('departureIATA') || '';
        var destinationIATA = Odigeo.Storage.get('destinationIATA') || '';
        return this.existsDepartureAndDestination(departureIATA, destinationIATA) && this.existsSegmentInMPIList(departureIATA, destinationIATA);
    },

    existsDepartureAndDestination: function(departureIATA, destinationIATA) {
        return !Odigeo._.isEmpty(departureIATA) && !Odigeo._.isEmpty(destinationIATA);
    },
    existsSegmentInMPIList: function(departureIATA, destinationIATA) {
        var segment = departureIATA + '-' + destinationIATA;
        return Odigeo._.contains(this.mpiRoutes, segment);
    },
    _getDataFirstResultPrice: function(data) {
        var price = 0;
        var result;

        if (Odigeo._.isUndefined(data)) {
            result = $('.result')[0];
        } else {
            result = $(data).find('.result')[0];
        }

        if (!Odigeo._.isUndefined(result) && this.widget.model && Odigeo._.isNumber(this.widget.model.cheapestPriceNotMatchedFilter)) {
            price = Odigeo._.min([this.widget.model.cheapestPriceNotMatchedFilter, result.getAttribute('data-price')]);
        } else if (!Odigeo._.isUndefined(result)) {
            price = result.getAttribute('data-price');
        }

        return price;
    },

    setCheapestItineraryPrice: function(price) {
        Odigeo.Session.set('cheapestItineraryPrice', price);
    },

    _getDataFirstResult: function(data) {
        var params = {};
        var price = this._getDataFirstResultPrice(data);
        var searchParameters;

        if (!Odigeo._.isUndefined(price)) {
            searchParameters = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
            params.typeTrip = Odigeo._.isNull(searchParameters) ? null : searchParameters.type;
            params.priceMinimus = Math.round(parseFloat(price));
            params.numFligths = this.widget.model.numberOfResults;
        }

        return params;
    },

    getRecommendedItinerary: function() {
        return Odigeo._.find(this.get('fareItineraries'), Odigeo._.matchesProperty('odiRating.highlightedTag', 'ODIRATING'));
    },

    getFareItineraryByIndexId: function(itineraryIndexId) {
        return Odigeo._.find(this.get('fareItineraries'), function(itinerary) {
            return itinerary.mainItineraryId.split(',')[0] === itineraryIndexId;
        });
    },
    getBestFlightItinerary: function() {
        return this.get('bestFlightsItinerary');
    },
    getItinerary: function(itineraryPosition) {
        if (Odigeo._.isObject(itineraryPosition)) {
            itineraryPosition = itineraryPosition.itinerary;
        }
        return this.get('fareItineraries')[itineraryPosition];
    },

    getLeg: function(positions) {
        return this.getItinerary(positions).itineraryGroupsList[positions.leg];
    },

    getSegment: function(positions) {
        var segments = this.getLeg(positions).segItems;
        return Odigeo._.find(segments, function(segment) {
            return segment.iterCountIndex === positions.segment;
        });
    },

    requestErrorHandler: function() {
        this.widget.pageBottomRequested -= 1;
        this.widget.view.$cachedSelectors.resultsPageContainer.hide();
        $('#flight-details').addClass('hidden');
        $('#filters-manager').addClass('hidden');
        $('#bread-crumbs').addClass('hidden');
    },

    landingToResultsFromMeta: function(data) {
        return this.widget.options.isResultHighlightedFromMeta && data.fareItineraryFromMetaSearch;
    },

    changeMainSearch: function(key) {
        if (!Odigeo._.isUndefined(key) && !Odigeo._.isNull(key)) {
            this.widget.clear();
            this.widget.selectedSearchResults = key;
            this.widget.view.loadResults(1);
            Odigeo.trigger(this.widget.id + ':reloadFilters');
        }
    },
    setSearchOrigin: function() {
        this.set('newSearch', true);
    },
    unSetSearchOrigin: function() {
        this.unset('newSearch');
    },
    isNewSearch: function() {
        return this.get('newSearch');
    },
});
